import React from "react";

import cx from "classnames";

import { ReactComponent as GoogleLogo } from "~/legacy-assets/images/logos/google.svg";
import { ReactComponent as TeamsLogo } from "~/legacy-assets/images/logos/microsoft-teams-icon.svg";
import { ReactComponent as MicrosoftLogo } from "~/legacy-assets/images/logos/microsoft.svg";
import { ReactComponent as OktaLogo } from "~/legacy-assets/images/logos/okta.svg";
import { ReactComponent as OneLoginLogo } from "~/legacy-assets/images/logos/OneLoginSmall.svg";
import { ReactComponent as OpenID } from "~/legacy-assets/images/logos/openid-icon.svg";

import Button, { type ButtonProps } from "../Button";

import styles from "./AuthButton.module.css";

type AuthButtonProps = ButtonProps & {
	provider?: "Google" | "Microsoft" | "Teams" | "OKTA" | "ONE_LOGIN" | "CUSTOM";
	action: "login" | "signup";
};

export function getLoginProviderText(sso: FellowAccountSSO) {
	switch (sso.provider) {
		case "OKTA":
			return "Okta";

		case "ONE_LOGIN":
			return "OneLogin";

		case "CUSTOM":
			return sso.custom_name || "OIDC";

		default:
			return "default";
	}
}

const AuthButton = React.forwardRef<HTMLButtonElement, AuthButtonProps>((props, ref) => {
	let { provider, children, ...rest } = props;
	const logo = React.useMemo(() => {
		switch (provider) {
			case "Google":
				return <GoogleLogo className={styles.authLogo} />;

			case "Microsoft":
				return <MicrosoftLogo className={styles.authLogo} />;

			case "Teams":
				return <TeamsLogo className={styles.authLogo} />;

			case "OKTA":
				return <OktaLogo className={styles.authLogo} />;

			case "ONE_LOGIN":
				return <OneLoginLogo className={styles.authLogo} />;

			case "CUSTOM":
				return <OpenID className={styles.authLogo} />;

			default:
				return null;
		}
	}, [provider]);

	return (
		<Button {...rest} ref={ref} className={cx(styles.authButton, { [styles.authButtonTeams]: provider === "Teams" })}>
			{provider && (
				<div
					className={cx(styles.logoWrapper, {
						[styles.noBG]: provider === "ONE_LOGIN",
						[styles.subtleBG]: provider === "CUSTOM",
					})}
				>
					{logo}
				</div>
			)}
			<div>{children}</div>
		</Button>
	);
});

AuthButton.displayName = "AuthButton";

export default AuthButton;
